module.exports = __webpack_public_path__ + "img/DeleteForeverOutlined.f8f05629.svg";